<template>
	<div class="w-full bg-text py-2 md:py-3">
		<BaseContainer>
			<span class="font-semibold text-surface-light text-sm md:text-base">
				{{ $t('doorsale.progress_bar', { n: position, total: doorsaleStore.selectedCount }) }}
			</span>
		</BaseContainer>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue';
	import { useI18n } from 'vue-i18n';

	import BaseContainer from '@/components/ui/BaseContainer.vue';
	import { useDoorsaleStore } from '@/stores/doorsaleStore';

	const { t: $t } = useI18n();

	const props = defineProps<{
		eventId: number | string;
	}>();

	const doorsaleStore = useDoorsaleStore();
	const position = computed(() => doorsaleStore.selectedEventIds.indexOf(props.eventId) + 1);
</script>
